import { FC, MouseEvent, ReactElement } from 'react';
import cn from 'classnames';
import Button from 'core/components/forms/button';
import { Loader } from 'components/controls';
import './style.scss';

interface ISubmitButtonFormProps {
  isLoading?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  name: string | ReactElement;
  size?: 'big' | 'small';
  onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  endIcon?: ReactElement;
}

export const SubmitButtonForm: FC<ISubmitButtonFormProps> = (props) => {
  const {
    isLoading = false,
    name,
    disabled = false,
    size = 'big',
    type = 'submit',
    onClick,
    endIcon,
  } = props;

  const handleOnClick = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    onClick && onClick(event);
  };

  return (
    <div className={cn('shell-btn', size)}>
      <Button
        disabled={isLoading || disabled}
        type={type}
        // name={disabled ? name : isLoading ? '' : name}
        // startIcon={disabled ? null : isLoading ? <Loader size={size === 'big' ? 32 : 24} /> : null}
        name={isLoading ? '' : name}
        startIcon={isLoading ? <Loader size={size === 'big' ? 32 : 24} /> : null}
        className={disabled ? 'disabled' : isLoading ? 'loading' : ''}
        onClick={handleOnClick}
        endIcon={endIcon}
      />
    </div>
  );
};
